import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { AppModule } from '../app.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnergyComponent } from './energy/energy.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { RoutinesComponent } from './routines/routines.component';
import { DevicesComponent } from './devices/devices.component';
import { AuthenticationService } from '../core/services/authentication.service';
import { DevicesService } from './devices/devices.service';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DeviceTabComponent } from './devices/device-tab/device-tab.component';
import { DevicesModule } from './devices/devices.module';
// tslint:disable-next-line
import { SchedulingCreateDialogComponent } from './scheduling/scheduling-device/scheduling-create-dialog/scheduling-create-dialog.component';
// tslint:disable-next-line
import { SchedulingPlcUpdateDialogComponent } from './scheduling/scheduling-tab/scheduling-plc-update-dialog/scheduling-plc-update-dialog.component';
import { SchedulingService } from './scheduling/scheduling.service';
import { SchedulingModule } from './scheduling/scheduling.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { CategoriesService } from './devices/categories.service';
import { EditDialogComponent } from './devices/device-detail/edit-dialog/edit-dialog.component';
import { MatSelectModule, MatExpansionModule } from '@angular/material';
import { EnergyConsumptionComponent } from './energy/energy-consumption/energy-consumption.component';
import { EnergyGenerationComponent } from './energy/energy-generation/energy-generation.component';
import { EnergyResumeComponent } from './energy/energy-resume/energy-resume.component';
import { EnergyPowerComponent } from './energy/energy-power/energy-power.component';
import { EnergyPredictionComponent } from './energy/energy-prediction/energy-prediction.component';
import { GenerationResumeComponent } from './energy/energy-resume/generation-resume/generation-resume.component';
import { ConsumptionResumeComponent } from './energy/energy-resume/consumption-resume/consumption-resume.component';
import { EnergyModule } from './energy/energy.module';
// tslint:disable-next-line
import { SchedulingSchedulesDialogComponent } from './scheduling/scheduling-tab/scheduling-schedules-dialog/scheduling-schedules-dialog.component';
import { ScheduleCreateComponent } from './scheduling/schedule-create/schedule-create.component';
import { HomeTabComponent } from './home/home-tab/home-tab.component';
import { HomeFlowsViewComponent } from './home/home-tab/home-flows-view/home-flows-view.component';
import { HomeCellsViewComponent } from './home/home-tab/home-cells-view/home-cells-view.component';
import { BubbleChartComponent } from './home/home-tab/home-cells-view/bubble-chart/bubble-chart.component';
import { HomeService } from './home/home.service';
import { DonutChartComponent } from './home/home-tab/home-cells-view/donut-chart/donut-chart.component';
import { RoutinesModule } from './routines/routines.module';
import { AlertsModule } from './alerts/alerts.module';
import { ProfileComponent } from './profile/profile.component';
import { ProfileModule } from './profile/profile.module';
import { MessagesModule } from './messages/messages.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ContactsComponent } from '../shared/components/contacts/contacts.component';
import { FaqModule } from '../shared/components/faq/faq.module';
import { FaqComponent } from '../shared/components/faq/faq.component';
import { FlowDotComponent } from '../shared/components/flow-dot/flow-dot.component';
import { HousesService } from './houses/houses.service';
import { MicrogenerationFlowComponent } from './home/home-tab/home-flows-view/flows/microgeneration-flow/microgeneration-flow.component';
import { SelfConsumptionFlowComponent } from './home/home-tab/home-flows-view/flows/self-consumption-flow/self-consumption-flow.component';
import { ConsumptionFlowComponent } from './home/home-tab/home-flows-view/flows/consumption-flow/consumption-flow.component';
import { LoadingModule } from 'ngx-loading';
import { EfficiencyComponent } from './efficiency/efficiency.component';
import { EfficiencyTabComponent } from './efficiency/efficiency-tab/efficiency-tab.component';
import {MatRadioModule} from '@angular/material/radio';
import { EfficiencyService } from './efficiency/efficiency.service';
import { NgxCarouselModule } from 'ngx-carousel';
import { OptimizeDialogComponent } from './efficiency/redy-tips/optimize-dialog/optimize-dialog.component';
import { RedyTipsComponent } from './efficiency/redy-tips/redy-tips/redy-tips.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    DevicesModule,
    SchedulingModule,
    SharedModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSelectModule,
    EnergyModule,
    RoutinesModule,
    AlertsModule,
    ProfileModule,
    MessagesModule,
    MatTooltipModule,
    TranslateModule,
    MatExpansionModule,
    FaqModule,
    LoadingModule,
    MatRadioModule,
    NgxCarouselModule
  ],
  entryComponents: [
    SchedulingCreateDialogComponent,
    SchedulingPlcUpdateDialogComponent,
    SchedulingSchedulesDialogComponent,
    EditDialogComponent,
    OptimizeDialogComponent
  ],
  declarations: [
      HomeComponent,
      EditDialogComponent,
      HomeTabComponent,
      HomeFlowsViewComponent,
      ConsumptionFlowComponent,
      SelfConsumptionFlowComponent,
      MicrogenerationFlowComponent,
      HomeCellsViewComponent,
      BubbleChartComponent,
      DonutChartComponent,
      FaqComponent,
      FlowDotComponent,
      ContactsComponent,
      EfficiencyComponent,
      EfficiencyTabComponent,
      OptimizeDialogComponent,
      RedyTipsComponent,
  ],
  exports: [
    HomeComponent],
  providers: [
      CategoriesService,
      DevicesService,
      SchedulingService,
      HomeService,
      HousesService,
      EfficiencyService
  ]
})
export class EntitiesModule { }



// WEBPACK FOOTER //
// ./src/app/entities/entities.module.ts